export const getRightOrBottom = (rect, flexyInstance) => {
  if (flexyInstance.options.orientation === "vertical") {
    return rect.top + rect.height
  }

  return rect.right
}

export const getLeftOrTop = (rect, flexyInstance) => {
  if (flexyInstance.options.orientation === "vertical") {
    return rect.top
  }

  return rect.left
}

export const getDimensionFor = (rect, flexyInstance) => {
  if (flexyInstance.options.orientation === "vertical") {
    return rect.height
  }

  return rect.width
}
